import { Component, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-back-arrow-button',
    templateUrl: './back-arrow-button.component.html',
    styleUrl: './back-arrow-button.component.scss',
    imports: [MatButton, MatIcon],
})
export class BackArrowButtonComponent {
  label = input<string>();
  action = input<() => void>();
}
